export default __webpack_public_path__ + "static/media/yihetang.e3377691.jpg";